export const stockAccountStatusRequest = 1002;
export const stockAccountStatusNeedInfo = 1022;
export const stockAccountStatusOpenNHSVAccount = 1003;
export const stockAccountStatusUpdateNHSVAccount = 1004;
export const stockAccountStatusUpdateContractNumber = 1006;
export const stockAccountStatusVSDApproved = 1007;
export const stockAccountStatusVSDRejected = 1008;

export const stockAccountStatusColors = {
  1001: 'grey',
  [stockAccountStatusRequest]: 'yellow',
  [stockAccountStatusNeedInfo]: 'orange',
  [stockAccountStatusOpenNHSVAccount]: 'cyan',
  [stockAccountStatusUpdateNHSVAccount]: 'blue',
  [stockAccountStatusUpdateContractNumber]: 'purple',
  [stockAccountStatusVSDApproved]: 'green',
  [stockAccountStatusVSDRejected]: 'red',
};

export const stockAccountStatusOptions = [
  {
    label: 'Yêu cầu tạo tài khoản',
    value: stockAccountStatusRequest,
  },
  {
    label: 'Cần hỗ trợ xử lý',
    value: stockAccountStatusNeedInfo,
  },
  {
    label: 'Chưa hoàn tất - Open',
    value: stockAccountStatusOpenNHSVAccount,
  },
  {
    label: 'Chưa hoàn tất - Update',
    value: stockAccountStatusUpdateNHSVAccount,
  },
  {
    label: 'Chờ VSD duyệt',
    value: stockAccountStatusUpdateContractNumber,
  },
  {
    label: 'Sẵn sàng',
    value: stockAccountStatusVSDApproved,
  },
  {
    label: 'VSD từ chối',
    value: stockAccountStatusVSDRejected,
  },
];

export const stockAccountSourceColors = {
  nhsv: '#f8c000',
  stag: '#0836E6',
};

export const eSignContractStatusColors = {
  init: 'default',
  pending: 'gold',
  signing: 'blue',
  signed: 'cyan',
  complete: 'green',
  expired: 'red',
  rejected: 'red',
};

export const eSignContractStatusLabels = {
  init: 'Chưa tạo hợp đồng',
  pending: 'Đang tạo hợp đồng',
  signing: 'Chờ ký',
  signed: 'Đã ký, chờ duyệt',
  complete: 'Đã duyệt',
  expired: 'Hết hạn',
  rejected: 'Bị từ chối/huỷ',
};

export const eSignContractStatusOptions = [
  { label: eSignContractStatusLabels.init, value: 'init' },
  { label: eSignContractStatusLabels.pending, value: 'pending' },
  { label: eSignContractStatusLabels.signing, value: 'signing' },
  { label: eSignContractStatusLabels.signed, value: 'signed' },
  { label: eSignContractStatusLabels.complete, value: 'complete' },
  { label: eSignContractStatusLabels.expired, value: 'expired' },
  { label: eSignContractStatusLabels.rejected, value: 'rejected' },
];

export const mutualFundAccountStatusPending = 1001;
export const mutualFundAccountStatusVSDApproved = 1002;

export const mutualFundAccountStatusColors = {
  [mutualFundAccountStatusPending]: 'gold',
  [mutualFundAccountStatusVSDApproved]: 'green',
};

export const mutualFundAccountStatusLabels = {
  [mutualFundAccountStatusPending]: 'Chờ duyệt',
  [mutualFundAccountStatusVSDApproved]: 'VSD đã duyệt',
};
